import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import PageLoader from '../../../../../components/PageLoader';
import Popup from '../../../../../common/components/popup';
import { MembershipComponent } from '../components/membership.component';
import { mentors } from '../../../../../redux/mentors/action';
import { selectMentorsListItems } from '../../../../../redux/mentors/selector';
import { selectMembershipQueryItems } from '../../../../../redux/membership/selector';
import { membership } from '../../../../../redux/membership/action';
import ModalOneMembershipComponent from '../components/one-membership-modal.component';


const Membership = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [columnDefs, setColumnDefs] = useState({});
    const [selectOnePrograms, setSelectOnePrograms] = useState<any>([])
    const [addItem, setAddItem] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const mentorsListis = useSelector(selectMentorsListItems)
    const queryItems = useSelector(selectMembershipQueryItems)
    const [selectedMembershipValues, setSelectedMembershipValues] = useState([]);
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [
        selectedMember,
        setSelectedMember
    ] = useState<any>([])

    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])


    const fetchQueryById = () => {
        dispatch(membership.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/memberships/query`, entity: 'programHubs', jsonData: {
                Context: {},
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedMember({ ...selectedMember, [field]: event })
    }

    // media handle form change
    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }

    useEffect(
        () => {
            createColumnDefs()
            dispatch(mentors.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/mentors/list`,
                entity: 'mentors',
                jsonData: {}
            }))

                .then(() => {
                    if (parmas?.id > 0) {
                        fetchQueryById()

                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                const querydata: any = queryItems?.result?.items
                setSelectedMember(querydata)

                const oneProgramItemsData: any = queryItems?.result?.items?.ONEMemberships?.map((item: any) => {
                    const itemData = {
                        Id: item?.Id,
                        Name: item?.Name,
                        Description: item?.Description,
                        Duration: item?.Duration,
                        Price: item?.Price,
                        IncludedServices: item?.IncludedServices || [],
                        Specifications: item?.Specifications || [],
                        IsEnabled: item?.IsEnabled || false,
                        StartDateUtc: item?.StartDateUtc,
                        EndDateUtc: item?.EndDateUtc,
                        IsFreeOfCost: item?.IsFreeOfCost,



                    }
                    return itemData
                })
                console.log(oneProgramItemsData, 'oneProgramItemsData')
                setSelectedMembershipValues(oneProgramItemsData)

            }
        },
        [isQuery]
    )



    const back = () => {
        navigate('/management/onesp/membership')
    }



    //Save the modal data function
    const handleSaveItem = async (data: any) => {

        // Collect new form data

        const newItem = {
            Id: data?.Id || Date.now(),
            Name: data?.Name,
            Description: data?.Description,
            Duration: data?.Duration,
            Price: data?.Price,
            IncludedServices: data.IncludedServices,
            Specifications: data?.Specifications,
            IsEnabled: data?.IsEnabled || false,
            StartDateUtc: data?.StartDateUtc,
            EndDateUtc: data?.EndDateUtc,
            IsFreeOfCost: data?.IsFreeOfCost,
        }

        //Update the new data
        setSelectedMembershipValues((prevState: any) => {
            // Check if the item exists by ID
            const exists = prevState.some((item: any) => item.Id === newItem.Id);
            // If it exists, update it, otherwise add the new item
            return exists
                ? prevState.map((item: any) => item.Id === newItem.Id ? newItem : item)
                : [...prevState, newItem];
        });
        closeModal();
    }

    // Add button
    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add One Membership</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAddItem(),
        }
    ];

    //Table ColumnDef Function
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name' },
            { field: 'Duration', headerName: 'Duration' },
            { field: 'Price', headerName: 'Price', },


        ]);
    }

    //Add the data in the Table Function
    const handleAddItem = () => {
        setAddItem({
            id: 0
        });
    }

    //Table Edit Function
    const handleEdit = (itemData: any) => {
        setAddItem({
            id: itemData.id
        })
        setSelectOnePrograms(itemData)

    }

    //Table Delete Function
    const handleDelete = (data: any) => {
        setSelectedMembershipValues((prevState: any) =>
            prevState.filter((item: any) => item?.Id !== data?.Id)
        );

    };

    //Modal Close Function
    const closeModal = () => {
        setAddItem(undefined)
        setSelectOnePrograms('')
    }

    // Modal Function
    const NewItemPopup = ({ handleSaveItem }: any) => {
        const [localItems, setLocalItems] = useState(deepCopy(selectOnePrograms));
        const handleLocalFormChange = (value: any, field: any) => {
            setLocalItems((prev: any) => ({
                ...prev,
                [field]: value,
            }));
        };
        const handleItemSubmit = () => {
            setLocalItems(localItems);
            handleSaveItem(localItems)
        };
        return (
            <>
                <Popup onClose={closeModal}>
                    <ModalOneMembershipComponent
                        Close={closeModal}
                        mentors={mentorsListis?.result?.items}
                        handleItemSubmit={handleItemSubmit}
                        selectedPlans={localItems}
                        onInnerModalFormChange={handleLocalFormChange}

                    />

                </Popup>
            </>
        )
    }

    // Submit the program Function
    const handleFormSubmit = async (event: any) => {

        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )
        console.log(selectedMember?.Id, "selectedProgramsId")
        const oneProgramItemsData: any = selectedMembershipValues.map((item: any) => {
            const itemData = {
                // Id:item?.Id || 0,
                Name: item?.Name,
                Description: item?.Description,
                Duration: item?.Duration,
                Price: Number(item?.Price),
                IncludedServices: item?.IncludedServices || [],
                Specifications: item?.Specifications || [],
                IsEnabled: item?.IsEnabled || false,
                StartDateUtc: item?.StartDateUtc,
                EndDateUtc: item?.EndDateUtc,
                IsFreeOfCost: item?.IsFreeOfCost,

            }
            return itemData
        })
        const programData = {


            "Id": selectedMember?.Id || 0,
            "IsActive": selectedMember?.IsActive,
            "IsEnabled": selectedMember?.IsEnabled,
            "Name": selectedMember?.Name,
            "Description": selectedMember?.Description,
            "StartDateUtc": selectedMember?.StartDateUtc,
            "EndDateUtc": selectedMember?.EndDateUtc,
            "ONEMemberships": oneProgramItemsData,
            "MediaMappings": {
                "MediaFiles": mediaFiles,
                "Templates": []

            }


        }
        if (parmas?.id > 0) {
            await dispatch(membership.resetAction({ actionType: 'update' }))
            await dispatch(membership.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/memberships`, entity: 'programHubs', jsonData: {
                    Context: {},
                    Records: [
                        programData
                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(membership.resetAction({ actionType: 'create' }))
            await dispatch(membership.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/memberships`, entity: 'programHubs', jsonData: {

                    Context: {},
                    Records: [
                        programData
                    ]

                }
            })).then(() => {
                back()
            })

        }

    }


    return (
        <>

            {
                addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
            }
            {isLoading ? <PageLoader /> :


                <MembershipComponent
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    selectedMember={selectedMember}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    onFormItemChange={handleFormMediaItemChange}
                    id={parmas?.id}
                    selectedMembershipValues={selectedMembershipValues}
                    columnDefs={columnDefs}
                    handleEdit={handleEdit}
                    additionButtons={additionButtons}
                    handleDelete={handleDelete}
                />
            }

        </>
    )

}

export default Membership;